import React from 'react';
import { useTranslation } from 'react-i18next';

const TopHeader = () => {
    const { t } = useTranslation();
    return (
        <div className="top-header-wrapper" style={{ backgroundColor: "#ffffff", borderBottom: "1px solid #e9ecef" }}>
          <div className="container" style={{ padding: "10px 15px" }}>
            <div className="row align-items-center">
              <div className="col-lg-5 col-md-5 col-sm-12 text-center text-md-start mb-2 mb-md-0">
                <img src="images/logo.jpeg" alt="Jo & Phoenicia Taxi" style={{ height: "70px", width: "auto", maxWidth: "100%", objectFit: "contain" }} />
              </div>
              <div className="col-lg-3 col-md-3 col-sm-6 text-center text-md-start mb-2 mb-md-0">
                <div className="unit unit-spacing-xs align-items-center justify-content-center justify-content-md-start">
                    <div className="unit-left"><span className="icon fa fa-clock-o" style={{ fontSize: "26px", color: "#C89B3C" }}></span></div>
                    <div className="unit-body">
                      <p style={{ fontSize: "14px", fontWeight: "600", color: "#162E44", margin: 0, lineHeight: "1.3" }}>
                        {t('Hours')} 24 / 7 {t('Days')}<br />{t('support availability')}
                      </p>
                    </div>
                  </div>
              </div>
              <div className="col-lg-4 col-md-4 col-sm-6 text-center text-md-end">
                <div className="unit unit-spacing-xs align-items-center justify-content-center justify-content-md-end">
                    <div className="unit-left"><span className="icon fa fa-phone" style={{ fontSize: "26px", color: "#C89B3C" }}></span></div>
                    <div className="unit-body">
                      <div style={{ fontSize: "15px", fontWeight: "700", color: "#162E44", lineHeight: "1.3" }}>
                        <a className="link-phone" href="tel:+96176672377" style={{ color: "#162E44", textDecoration: "none" }}>+961 76 672 377</a>
                        <span style={{ margin: "0 6px" }}>/</span>
                        <a className="link-phone" href="tel:+96171326929" style={{ color: "#162E44", textDecoration: "none" }}>+961 71 326 929</a>
                      </div>
                    </div>
                  </div>
              </div>
            </div>
          </div> 
        </div>
    );
}

export default TopHeader;
